// Anonymous, privacy-safe visitor tracking. A random visitorId is kept in
// localStorage (persists across sessions on this device); sessionId lives in
// sessionStorage. Only whitelisted event types / prop keys reach the backend.
import { api } from "@/lib/api";

const VID_KEY = "fcs_visitor_id";
const SID_KEY = "fcs_session_id";

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "v_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2);
}

export function getVisitorId() {
  let v = null;
  try {
    v = localStorage.getItem(VID_KEY);
    if (!v) {
      v = uuid();
      localStorage.setItem(VID_KEY, v);
    }
  } catch {
    v = v || uuid();
  }
  return v;
}

function getSessionId() {
  try {
    let s = sessionStorage.getItem(SID_KEY);
    if (!s) {
      s = uuid();
      sessionStorage.setItem(SID_KEY, s);
    }
    return s;
  } catch {
    return uuid();
  }
}

export function track(eventType, props) {
  try {
    api
      .track({
        eventType,
        visitorId: getVisitorId(),
        sessionId: getSessionId(),
        path: typeof window !== "undefined" ? window.location.pathname : null,
        referrer: typeof document !== "undefined" ? document.referrer || null : null,
        props: props || {},
      })
      .catch(() => {});
  } catch {
    /* analytics must never break the UI */
  }
}

// Meta Pixel custom event: fired ONCE per completed assessment (caller guards
// with a ref). PRIVACY: no parameters are ever attached — the event only marks
// that an assessment finished, never any financial/personal data.
export function trackCekSelesai() {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("trackCustom", "CekSelesai");
    }
  } catch {
    /* pixel must never break the UI */
  }
}
